import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

export const SearchHeroInputsSearchHolder = styled.div`
  height: 100%;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    flex: 2;
  }
`;

export const SearchHeroInputsFooter = styled.footer`
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${spacing[24]};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-top: 0;
  }
`;

export const SearchHeroInputsActionContainer = styled.div`
  flex: 0 0 auto;
  height: 100%;
  display: block;
  margin-top: 16px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: flex;
  }
`;
